import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild, AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDeleteDialogComponent } from 'src/app/shared/confirm-delete-dialog/confirm-delete-dialog.component';


@Component({
  selector: 'app-bidding-list',
  templateUrl: './bidding-list.component.html',
  styleUrl: './bidding-list.component.css'
})
export class BiddingListComponent implements OnInit {
  displayedColumns: string[] = ['srNo', 'projectName', 'clientName', 'contactName', 'email', 'workDescription', 'bidFees', 'bidStartDate', 'bidEndDate', 'status', 'action'];

  dataSource = new MatTableDataSource<any>([]);
  searchKeyword = '';
  currentStatusFilter = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fetchData();
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const matchStatus = !this.currentStatusFilter ||
        (data.status && data.status.toLowerCase() === this.currentStatusFilter.toLowerCase());
      const searchStr = [
        data.projectName,
        data.clientName,
        data.contactName,
        data.email,
        data.orgName,
        data.workDescription,
        data.status
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
      const matchSearch = !filter || searchStr.indexOf(filter.toLowerCase()) !== -1;
      return matchStatus && matchSearch;
    };
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim();
    this.dataSource.filter = filterValue;
  }

  filterByStatus(event: any) {
    this.currentStatusFilter = (event.target as HTMLSelectElement)?.value || '';
    this.dataSource.filter = this.dataSource.filter || ' ';
  }

  fetchData() {
    this.apiService.getProjectBidding().subscribe({
      next: (res: any) => {
        this.dataSource.data = res?.data ?? res ?? [];
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.errorMessage || err?.error?.error || 'Failed to load bidding list');
      }
    });
  }

  deleteBidding(item: any) {
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: '400px',
      data: { itemName: item.projectName || item.clientName || 'this bidding record' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.apiService.deleteProjectBidding(item.id).subscribe({
          next: () => {
            this.toastrMsgService.success('Bidding record deleted successfully');
            this.fetchData();
          },
          error: (err) => {
            this.toastrMsgService.error(err?.error?.errorMessage || err?.error?.error || 'Failed to delete');
          }
        });
      }
    });
  }

  getStatusClass(status: string): string {
    if (!status) return 'bg-gray-100 text-gray-800';
    const s = status.toLowerCase();
    if (s === 'pending') return 'bg-yellow-100 text-yellow-800';
    if (s === 'verified' || s === 'accepted') return 'bg-green-100 text-green-800';
    if (s === 'rejected') return 'bg-red-100 text-red-800';
    return 'bg-gray-100 text-gray-800';
  }

  formatCurrency(amount: any): string {
    if (amount == null || amount === '') return '—';
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(num || 0);
  }

  truncate(text: string, maxLen: number = 40): string {
    if (!text) return '—';
    return text.length > maxLen ? text.substring(0, maxLen) + '…' : text;
  }

  viewBidding(element: any): void {
    this.router.navigate(['/home/project-binding/view', element.id]);
  }
}